import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Input } from 'shared/components/';
import { MATERIAL_SERIAL_NUMBER_LENGTH } from 'shared/constants';
import { find } from 'lodash';
import RemoveIcon from 'assets/svgs/removeRed.svg';

import './Range.scss';

const Range = ({
  index,
  count,
  rangeBegin,
  rangeEnd,
  materialType,
  handleChange,
  handleRemove,
  showRemoveBtn,
  errors,
}) => {
  const { t } = useTranslation();

  let rangeErrors;

  if (errors) {
    rangeErrors = (errors && find(errors, (e) => e.totalCount || e.fieldsMandatory)) || {};
    rangeErrors.range = [];
    errors.map((err) => {
      if (!err.fieldsMandatory && !err.rangeUsedUnused) {
        rangeErrors.range.push(err.message);
      }
      if (err.rangeUsedUnused) {
        rangeErrors.rangeUsedUnused = err.rangeUsedUnused;
      }
    });
  }

  return (
    <div className="material-range-container">
      <div className="material-range">
        <div className="range">
          <div className="mobile-only header">
            {t('testCenter.testMaterialsRanges.rangesLabel')} - {materialType.name}{' '}
            {t('testCenter.testMaterialsRanges.serialNumberLabel')}
          </div>
          <Input
            type="number"
            name={`rangeBegin-${index}`}
            value={rangeBegin}
            leadingZero={false}
            onChange={(e) => handleChange(e, materialType.id)}
            errors={rangeErrors && (rangeErrors.rangeBegin || rangeErrors.range)}
            maxLength={MATERIAL_SERIAL_NUMBER_LENGTH}
            showMaxLength={true}
          />
          <span>-</span>
          <Input
            type="number"
            name={`rangeEnd-${index}`}
            value={rangeEnd}
            leadingZero={false}
            onChange={(e) => handleChange(e, materialType.id)}
            errors={rangeErrors && (rangeErrors.rangeEnd || rangeErrors.range)}
            maxLength={MATERIAL_SERIAL_NUMBER_LENGTH}
            showMaxLength={true}
          />
        </div>

        <div className="total">
          <div className="mobile-only header">
            {t('testCenter.testMaterialsRanges.totalBookletsLabel')}{' '}
            {t('testCenter.testMaterialsRanges.perRangeLabel')}
          </div>
          <Input
            type="number"
            name={`count-${index}`}
            value={count}
            onChange={(e) => handleChange(e, materialType.id)}
            errors={rangeErrors && (rangeErrors.count || rangeErrors.totalCount)}
          />
        </div>

        <div className="actions">
          {showRemoveBtn && (
            <button
              className="btn-link text-pacific-blue text-strong remove-button"
              onClick={() => handleRemove(materialType.id, index)}>
              <span className="fw-bold">
                {t('common.labels.remove')}
                <RemoveIcon />
              </span>
            </button>
          )}
        </div>

        {rangeErrors &&
          rangeErrors.range &&
          rangeErrors.range.map((error, index) => (
            <div className="text-error" key={index}>
              {t(error)}
            </div>
          ))}
        {rangeErrors && rangeErrors.rangeUsedUnused && (
          <div className="text-error">{t(rangeErrors.rangeUsedUnused)}</div>
        )}
      </div>
      <div className="range-errors-container">
        <div>
          {rangeErrors && rangeErrors.rangeBegin && (
            <div className="text-error">{t(rangeErrors.rangeBegin[0])}</div>
          )}
        </div>
        <div>
          {rangeErrors && rangeErrors.rangeEnd && (
            <div className="text-error">{t(rangeErrors.rangeEnd[0])}</div>
          )}
        </div>
      </div>
    </div>
  );
};

Range.propTypes = {
  index: PropTypes.number,
  count: PropTypes.number,
  rangeBegin: PropTypes.string,
  rangeEnd: PropTypes.string,
  materialType: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func,
  handleLeadingZero: PropTypes.func,
  handleRemove: PropTypes.func,
  showRemoveBtn: PropTypes.bool,
  roomClosed: PropTypes.bool,
  unusedCount: PropTypes.number,
  usedCount: PropTypes.number,
  errors: PropTypes.arrayOf(PropTypes.shape({})),
};

export default Range;
